<template>
  <div class="match-block" :title="`${this.properties['SYSTEM_LABEL-NEARMATCH']}`">
    <font-awesome-icon :icon="['fas','square-full']" size="xs"/>
    <font-awesome-icon :icon="['fas','square-full']" class="has-text-warning" size="xs"/>
    <font-awesome-icon :icon="['fas','square-full']" class="has-text-warning" size="xs"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSquareFull } from '@fortawesome/pro-solid-svg-icons';

library.add(faSquareFull);

export default {
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
  },
};
</script>

<style lang="sass" scoped>
  @import "@/sass/custom.sass"

  .match-block
    margin-top: .25rem
    display: flex
    flex-direction: column
    justify-content: center
    height: 100%
    color: #eee
    align-items: center
    & > *
      margin-bottom: .25rem
    &:last-child
      margin-bottom: none

  // .match-block
  //   display: flex
  //   flex-direction: column
  //   justify-content: center
  //   height: 100%
  //   // padding: 1rem
  //   color: #eee
  //   & > *
  //     margin-bottom: .25rem
  //   &:last-child
  //     margin-bottom: none
  .is-warning
    color: #ffc107
</style>
